import { useParams } from 'react-router-dom'

import Loading from '../components/layout/Loading'
import ErrorMessage from '../components/errors/ErrorMessage'
import PdfViewer from '../components/pdf'
import PageHeading from '../components/layout/PageHeading'
import { useDocumentById } from '../../hocs/content/useDocuments'

const DocumentReader = () => {
  const { id } = useParams()
  if(!id) return <div>Invalid document id</div>
  const { data, isLoading, error } = useDocumentById(id)
  if(isLoading || !data) {
    return <Loading message='Loading' />
  }

  return (
    <div>
      <PageHeading>{data.title}</PageHeading>
      {error && <ErrorMessage error={error} />}
      {!error && <PdfViewer pdfFile={data.srcUrl} isFullScreen />}
    </div>
  )
}

export default DocumentReader
